/* istanbul ignore file */
import {EdapEventFields} from './helpers';

const sendEdapEvent = (context, event, options) => {
    if (context.hasProvider) {
        context.trigger(event, options);
    } else {
        window.edap = window.edap || [];
        window.edap.push((edap) => {
            edap.trigger(event, options);
        });
    }
};

const getEventOptions = (label, messageValueType) => {
    return {
        eventcategory: EdapEventFields.CATEGORY,
        eventlabel: label,
        eventaction: messageValueType
    };
};

export function emitUrgencyUnitMessageEvent(context, messageValueType) {
    const {EVENT, UNIT_MESSAGE_LABEL} = EdapEventFields;
    const eventOptions = getEventOptions(UNIT_MESSAGE_LABEL, messageValueType);
    sendEdapEvent(context, EVENT, eventOptions);
}

export function emitUrgencyDestinationMessageEvent(context, messageValueType) {
    const {EVENT, DESTINATION_MESSAGE_LABEL} = EdapEventFields;
    const eventOptions = getEventOptions(DESTINATION_MESSAGE_LABEL, messageValueType);
    sendEdapEvent(context, EVENT, eventOptions);
}
